import * as React from 'react';
import { connect } from 'react-redux';
import DataTable from '../../DataTable';
import moment from 'moment';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import { Modal, Button } from 'react-bootstrap';
import { GetURIByParts } from '../../../services/Utils/StringUtils';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { DateRangePicker } from 'react-dates';
import ReactDOM from 'react-dom';
import { toast } from 'react-toastify';
import {
  searchPaperReports,
  openReport,
  assignAndOpen,
  unAssign,
} from './redux-objects/actions';
import AdhocNotificationButton from '../../Notifications/AdhocNotification/AdhocNotificationButton';
import { IWorkflowItem, IWorkflowItemStep } from '../../../common/sharedTypes';
import { Redirect } from 'react-router-dom';
import { UserInfo, hasPermission } from '../../Login/common/defaults';

import ViewAllButton from '../../DocumentViewer/ViewAllButton';
import MergedIndicator from '../common/MergedIndicator';
import { Provider } from 'react-redux';
import store from '../../../store/Store';
import rootReducer from '../../../store/Reducers';
const reduxStore = store({}, rootReducer);

import * as documentDownloadService from '../../../services/documentDownloadService';
import { QueueStartDate } from '../common';

const $ = require('jquery');
$.DataTable = require('datatables.net-bs4');

export interface IDataEntryQueueActionProps {
  searchPaperReports?: (url: string) => void;
  openReport?: (id: number) => Promise<void>;
  assignAndOpen?: (
    url: string,
    stepItemId: number,
    assignToId: number
  ) => Promise<void>;
  unAssign?: (url: string, stepItemId: number) => Promise<void>;
}

interface IDataEntryQueueStateProps {
  workflowItemSteps: IWorkflowItemStep[];
  webServiceURL: string;
  isProcessing: boolean;
  history: any;
  currentUser: UserInfo;
}

interface IDataEntryQueueProps
  extends IDataEntryQueueActionProps,
  IDataEntryQueueStateProps { }

enum ModalMode {
  None,
  New,
  Editing,
}

enum ServiceEndPoints {
  SearchPaperReportDataQueue = 'SearchDataEntryQueue',
  AssignWorkflowItemStep = 'AssignWorkflowItemStep',
  UnAssignWorkflowItemStep = 'UnAssignWorkflowItemStep',
}

const initialState = {
  userOnly: false,
  assignedOnly: false,
  startDate: moment(QueueStartDate),
  endDate: moment(),
  focusedInput: null,
  showModal: false,
  modalStatus: ModalMode.None,
  openingReport: false,
  includeNewDriverReports: false,
};
type DataEntryQueueState = Readonly<typeof initialState>;

class DataEntryQueue extends React.Component<
  IDataEntryQueueProps,
  DataEntryQueueState
> {
  public constructor(props: IDataEntryQueueProps) {
    super(props);
    this.state = initialState;
  }

  // TODO: Refactor to configuration file
  private workflowController: string = 'Workflow';
  private includeNewDriverReports: string =
    'DataEntryIncludeNewDriverReportsCheckbox';
  private assignedOnly: string = 'DataEntryAssignedOnlyCheckbox';
  private userOnly: string = 'DataEntryUserOnlyCheckbox';

  componentDidMount() {
    const { workflowItemSteps } = this.props;
    this.populatePaperReports();

    // if (workflowItemSteps.length === 0) {
    // }
  }

  getLocalStorageItem(key) {
    try {
      let item: string = window.localStorage.getItem(key);
      let checkboxFlag = null;
      if (item == 'true') checkboxFlag = true;
      if (item == 'false') checkboxFlag = false;
      return checkboxFlag ? checkboxFlag : null;
    } catch (error) {
      console.log(error);
      return false;
    }
  }

  setLocalStorageItem(key, value) {
    window.localStorage.setItem(key, value);
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      console.log(error);
    }
  }

  closeModal = (e?) => {
    this.toggleScrollLock();
    this.setState({
      modalStatus: ModalMode.None,
      showModal: false,
    });
  };

  toggleScrollLock = () => {
    document.querySelector('html').classList.toggle('scroll-lock');
  };

  handleAssignedOnlyCheck(isChecked) {
    this.setLocalStorageItem(this.assignedOnly, isChecked);
    this.setState({ assignedOnly: isChecked }, () => {
      this.populatePaperReports();
    });
  }

  handleIncludeNewDriverReports(includeNew: any) {
    this.setLocalStorageItem(this.includeNewDriverReports, includeNew);
    this.setState(
      {
        includeNewDriverReports: includeNew,
      },
      () => {
        this.populatePaperReports();
      }
    );
  }

  handleUserCheck(userChecked) {
    this.setLocalStorageItem(this.userOnly, userChecked);
    this.setState({ userOnly: userChecked }, () => {
      this.populatePaperReports();
    });
  }

  handleDatesChanged(startDate, endDate) {
    if (startDate && endDate) {
      this.setState({ startDate, endDate }, () => {
        this.populatePaperReports();
      });
    }
  }

  refreshPaperReports() {
    this.populatePaperReports();
  }
  populatePaperReports() {
    let uri = GetURIByParts(
      this.props.webServiceURL,
      this.workflowController,
      ServiceEndPoints.SearchPaperReportDataQueue
    );
    let persistentUserOnly = this.getLocalStorageItem(
      'DataEntryUserOnlyCheckbox'
    );
    let persistentAssignedOnly = this.getLocalStorageItem(
      'DataEntryAssignedOnlyCheckbox'
    );
    let persistentIncludeNewDriverReports = this.getLocalStorageItem(
      'DataEntryIncludeNewDriverReportsCheckbox'
    );
    var params = {
      userOnly: persistentUserOnly ? persistentUserOnly : false,
      assignedOnly: persistentAssignedOnly ? persistentAssignedOnly : false,
      startDate: this.state.startDate.toDate().toUTCString(),
      endDate: this.state.endDate.toDate().toUTCString(),
      statusId: null,
      queue: -3,
      includeNewDriverReports: persistentIncludeNewDriverReports
        ? persistentIncludeNewDriverReports
        : false,
    };

    var esc = encodeURIComponent;
    var query = Object.keys(params)
      .map((k) => esc(k) + '=' + esc(params[k]))
      .join('&');

    uri = uri + '?' + query;
    this.props.searchPaperReports(uri);
  }

  handleOpenReport(event: React.MouseEvent<HTMLElement>, rowData: any) {
    let reportId = rowData?.reportId;
    let docId = rowData?.documentId;
    if (reportId == 0 && docId == null) {
      toast.error('Could not find report PDF');
      return;
    } else {
      documentDownloadService.openOnBaseImage(reportId, docId).then();
    }
  }

  handleAssignAndOpen(event: React.MouseEvent<HTMLElement>, rowData: any) {
    let uri = GetURIByParts(
      this.props.webServiceURL,
      this.workflowController,
      ServiceEndPoints.AssignWorkflowItemStep
    );
    const workflowItemStepId = Number(event.toString());

    if (rowData.assignedTo == this.props.currentUser.username) {
      this.props.openReport(workflowItemStepId).then(() => {
        this.props.history.push('/DataEntryForm');
      });
    } else {
      this.props.assignAndOpen(uri, workflowItemStepId, null).then(() => {
        this.props.history.push('/DataEntryForm');
      });
    }
    // do stuff
  }

  handleUnAssign(event: React.MouseEvent<HTMLElement>, rowData: any) {
    let uri = GetURIByParts(
      this.props.webServiceURL,
      this.workflowController,
      ServiceEndPoints.UnAssignWorkflowItemStep
    );
    this.props.unAssign(uri, rowData).then(() => {
      console.log('unassigned');
    });
  }

  showFrontSheet = (rowData) => {
    console.log('workflowItemStep from data entry queue', rowData);
    documentDownloadService.getFrontSheet(rowData.reportId);
  };

  public render() {
    const columnDefs = [
      {
        targets: 0,
        width: '250px',
        createdCell: (td, cellData, rowData, row, col) =>
          ReactDOM.render(
            <div className='buttonColumn'>
              <Provider store={reduxStore}>
                <ViewAllButton reportId={rowData.reportId} className='' />
              </Provider>
              {'  '}
              <Button
                variant='outline-info'
                size='sm'
                data-id={cellData}
                onClick={(e) => this.showFrontSheet(rowData)}
              >
                {'   '}
                View Front Sheet
              </Button>
              <Button
                variant='outline-primary'
                size='sm'
                data-id={cellData}
                onClick={(e) => this.handleOpenReport(cellData, rowData)}
              >
                {'   '}
                View
              </Button>{' '}
              {(!rowData.assignedTo ||
                rowData.assignedTo == this.props.currentUser.username) && (
                  <Button
                    variant='outline-primary'
                    size='sm'
                    data-id={cellData}
                    onClick={(e) => this.handleAssignAndOpen(cellData, rowData)}
                  >
                    {'   '}
                    {rowData.assignedTo == this.props.currentUser.username
                      ? 'Continue'
                      : 'Start'}
                  </Button>
                )}
              {'   '}
              {rowData.assignedTo &&
                hasPermission(this.props.currentUser, 'Reviewer') && (
                  <Button
                    variant='outline-danger'
                    size='sm'
                    data-id={cellData}
                    onClick={(e) => this.handleUnAssign(cellData, rowData)}
                  >
                    {'   '}
                    Unassign
                  </Button>
                )}
            </div>,
            td
          ),
      },
      {
        targets: 1,
        type: 'date',
        render: function (data) {
          return moment(data).format('lll');
        },
      },
      {
        targets: 7,
        visible: false,
      },
      {
        targets: 8,
        createdCell: (td, cellData, rowData, row, col) =>
          ReactDOM.render(
            <>{cellData}
              <MergedIndicator
                supplementedReports={rowData.supplementedReports}
                reportsMergedToThis={rowData.reportsMergedToThis}
                pendingMerge={rowData.pendingMerge}
              />
            </>,
            td)
      }
    ];

    const columns = [
      {
        title: 'Available Actions',
        data: 'id',
      },
      {
        title: 'Date Submitted',
        data: 'dateSubmitted',
      },
      {
        title: 'Workflow Status',
        data: 'workflowStatus',
      },
      {
        title: 'Assigned To',
        data: 'assignedTo',
      },
      {
        title: 'Document Id',
        data: 'documentId',
      },
      {
        title: 'County',
        data: 'county',
      },
      {
        title: 'Priority',
        data: 'priority',
      },
      {
        title: 'hidden',
        data: 'priorityNumber',
      },
      {
        title: 'Crash Key',
        data: 'originalCrashKey',
      },
    ];

    const options = {
      className: 'table table-striped table-bordered',
      select: false,
      dom: 'frtipB',
      orderFixed: {
        pre: [7, 'asc'],
      },
    };

    return (
      <div className='app'>
        <div className='row'>
          <div className='col-sm-6'>
            <h3>Data Entry Queue</h3>
          </div>
        </div>

        <hr />
        <Form>
          <Form.Row>
            <Form.Group as={Col} controlId='dataEntryQueueStartDate'>
              <Form.Label>Created Date</Form.Label>
              <br />
              <DateRangePicker
                startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                startDateId='dataEntryQueueStartDate' // PropTypes.string.isRequired,
                endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                endDateId='dataEntryQueueEndDate' // PropTypes.string.isRequired,
                onDatesChange={({ startDate, endDate }) =>
                  this.handleDatesChanged(startDate, endDate)
                } // PropTypes.func.isRequired,
                focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                onFocusChange={(focusedInput) =>
                  this.setState({ focusedInput })
                } // PropTypes.func.isRequired,
                isOutsideRange={() => false}
                small={true}
                block={false}
                minimumNights={0}
              />
            </Form.Group>
            <Form.Group controlId='formBasicCheckbox'>
              <Form.Check
                type='checkbox'
                label=' Show only Assigned'
                checked={this.getLocalStorageItem(this.assignedOnly)}
                onChange={(e) => this.handleAssignedOnlyCheck(e.target.checked)}
              />
            </Form.Group>
            &nbsp;&nbsp;&nbsp;
            <Form.Group controlId='AssignedMe'>
              <Form.Check
                type='checkbox'
                label=' Show only Assigned to Me'
                checked={this.getLocalStorageItem(this.userOnly)}
                onChange={(e) => this.handleUserCheck(e.target.checked)}
              />
            </Form.Group>
            &nbsp;&nbsp;&nbsp;
            <Form.Group controlId='NewDriver'>
              <Form.Check
                type='checkbox'
                label=' Held Driver Reports'
                checked={this.getLocalStorageItem(this.includeNewDriverReports)}
                onChange={(e) =>
                  this.handleIncludeNewDriverReports(e.target.checked)
                }
              />
            </Form.Group>
          </Form.Row>
          <Form.Row />
        </Form>
        {this.props.workflowItemSteps && (
          <DataTable
            id='tblQueuedNotifications'
            data={this.props.workflowItemSteps}
            columns={columns}
            columnDefs={columnDefs}
            actionsColumn='first'
            select={false}
            {...options}
          />
        )}
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    workflowItemSteps: state.DataEntryQueue.workflowItemSteps,
    webServiceURL: state.Application.backendURL,
    currentUser: state.Application.currentUser,
  };
}

const mapDispatchToProps = {
  searchPaperReports,
  openReport,
  assignAndOpen,
  unAssign,
};

export default connect(mapStateToProps, mapDispatchToProps)(DataEntryQueue);
